import { api } from '../../api'
import { ApiParams, DriversResponse } from '../../types'

const getDrivers = async ({ filters }: ApiParams) => {
  const response = await api.get<DriversResponse>('/drivers', {
    params: filters,
  })

  return response.data.drivers
}

const DriversApi = { getDrivers }

export default DriversApi
